import { useNavigate } from "react-router-dom";
import { ArrowRight, ShieldCheck, Scale, Lock, HeartHandshake } from "lucide-react";
import { Button } from "@/components/ui/button";
import SiteLayout from "@/components/SiteLayout";
import { CLIENT_LINE } from "@/lib/content";

export default function ChiSiamo() {
  const navigate = useNavigate();
  return (
    <SiteLayout
      seo={{ title: "Chi siamo", description: "OKKIO è una piattaforma indipendente di analisi dei preventivi di ristrutturazione. Non è un’impresa edile e non vende ristrutturazioni. Il nostro cliente sei tu, non l’impresa.", path: "/chi-siamo" }}
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "Chi siamo", to: "/chi-siamo" }]}
      narrow>
      <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.1]">Chi siamo</h1>
      <p className="mt-5 text-lg text-slate-600 leading-relaxed">
        OKKIO nasce da un’idea semplice: chi ristruttura casa dovrebbe poter capire il proprio preventivo prima di firmarlo,
        senza dover essere un tecnico.
      </p>

      <div className="mt-8 rounded-3xl bg-slate-900 text-white p-8 sm:p-10">
        <p className="font-heading text-2xl sm:text-3xl font-medium leading-snug">{CLIENT_LINE}</p>
        <p className="mt-4 text-slate-300 leading-relaxed">
          Siamo una piattaforma indipendente di analisi dei preventivi. Non siamo un’impresa edile, non vendiamo
          ristrutturazioni e non riceviamo compensi dalle imprese analizzate.
        </p>
      </div>

      <div className="mt-8 space-y-4">
        {[
          { icon: ShieldCheck, t: "Indipendenza", d: "Nessun conflitto di interesse: non guadagniamo indirizzando lavori a nessuno." },
          { icon: Scale, t: "Neutralità", d: "Non modifichiamo l’esito dell’analisi per favorire imprese partner." },
          { icon: Lock, t: "Trasparenza", d: "Distinguiamo sempre fatti, inferenze e benchmark, con i relativi limiti." },
          { icon: HeartHandshake, t: "Prudenza", d: "Non usiamo allarmismi: ti diciamo cosa verificare, non cosa temere." },
        ].map((c) => (
          <div key={c.t} className="rounded-2xl border border-slate-200 bg-white p-6 flex items-start gap-4">
            <span className="w-11 h-11 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0"><c.icon className="w-5 h-5 text-slate-700" strokeWidth={1.75} /></span>
            <div>
              <h2 className="font-heading font-semibold text-slate-900">{c.t}</h2>
              <p className="mt-1 text-sm text-slate-600 leading-relaxed">{c.d}</p>
            </div>
          </div>
        ))}
      </div>

      <Button data-testid="cs-cta" onClick={() => navigate("/controlla-preventivo")}
        className="mt-8 rounded-full h-14 px-8 text-base font-semibold bg-[#3157F6] hover:bg-[#2444D8] active:scale-95 transition-transform">
        Controlla il tuo preventivo <ArrowRight className="w-5 h-5 ml-1" />
      </Button>
    </SiteLayout>
  );
}
